import { Subject } from 'rxjs/Subject';
/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class NotificationService {
    private notificationCount = new Subject<number>()

    constructor() { }

    public setNotificationCount(count: number) {
        if (count >= 0) {
            this.notificationCount.next(count);
        }
    }

    public clearNotificationCount() {
        this.notificationCount.next();
    }

    public getNotificationCount(): Observable<number> {
        return this.notificationCount.asObservable();
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/notifications/services/notification.service.ts